/**
 * P.js
 * Styled Component for P
 */
import styled from 'styled-components'

// Styles
const P = styled.p`
    color: ${props => props.theme.colors.contentText};
`

export default P;